<fieldset class="border p-2 rounded-2">
  <legend class="w-auto px-2 ms-2 float-none fs-5">Organization: 
    <span class="badge text-bg-warning" style="padding: 2px 5px;">{{org.org_code}}</span>
  </legend>
  <div class="mx-2 d-flex justify-content-between" style="margin-top: -10px;">
    <div>
      <h5 class="card-title"><i class="bi bi-house-gear"></i>
        {{org.org_name}}
      </h5>
      <h6 class="card-subtitle mb-2 text-body-secondary">Reg. Date: {{org.reg_date | date: 'dd-mm-yyyy hh:mm'}}</h6>
    </div>
    <div>
      <p class="card-text text-end">{{org.org_address}},<br>{{org.org_city}} - {{org.org_pincode}}</p>
    </div>
  </div>
</fieldset>
<ng-container *ngIf="orgData && orgData.length">
@for(orgd of orgData; track $index; let idx=$index;) {
  <!-- {{orgd|json}} -->
<div class="row g-3 mt-0">
  <div class="col-sm-4 mb-3 mb-sm-0">
    <fieldset class="border p-2 rounded-2" style="height: 100%;">
      <legend class="w-auto px-2 ms-2 float-none fs-5">Institute {{idx+1}}: <span class="badge text-bg-info" style="padding: 2px 5px;">{{orgd?.institute?.inst_code}}</span></legend>
      <div class="mx-2" style="margin-top: -10px;">
        <h5 class="card-title"><i class="bi bi-buildings"></i>
          {{orgd?.institute?.inst_name}}
        </h5>

        <span class="ms-4">({{dataService.getInstituteType(orgd?.institute?.inst_type)}})</span>
        <div>Url: <a href="{{orgd?.institute?.website}}" target="_NEW">{{orgd?.institute?.website}}</a></div>

        <div class="my-3" style="line-height: normal;">Address: {{orgd?.institute?.address}},<br>
        {{orgd?.institute?.city}} - {{orgd?.institute?.pincode}}<br>
        {{orgd?.institute?.state}}</div>

        <div>ERP Key: {{orgd.users[0].erp_key}}&nbsp;&nbsp;
        <i class="bi bi-copy" style="cursor: pointer; font-size: 13px;" title="Copy Autologin URL"
          (click)="copyURL(orgd.users[0].erp_key)"></i>


        </div>
        <div>License Key: {{orgd?.institute?.agr_lickey}}</div>

        <div>Modules: {{orgd?.institute?.selected_modules}}</div>

        <div>Reg. Date: {{orgd?.institute?.reg_date | date: 'dd-MM-yyyy'}}</div>
        <!-- <span data-bs-toggle="dropdown">{{orgd?.institute?.exp_date | date: 'dd-MM-yyyy'}}</span> -->
        <div class="d-flex justify-content-between align-items-center mt-2" style="flex-wrap: balance;">
          <div>Exp. Date:</div>
          <div class="d-flex input-group" style="width: 70%;">
            <input type="date" class="form-control" [(ngModel)]="orgd.package.exp_date"
              style="max-width: 140px; height: 28px;">
            <button class="btn btn-sm btn-success py-0" style="height: 32px;"
              (click)="changeExpDate(orgd)">Update!</button>
          </div>
        </div>
      </div>
    </fieldset>
  </div>
  <div class="col-sm-8">
    <span class="paper-pin pin-top"><i class="bi bi-arrows"></i></span>
    <span class="paper-pin pin-bottom"><i class="bi bi-arrows"></i></span>

<div class="btn-group py-0" style="position: absolute; right: 30px;">
  <button type="button" class="btn btn-sm btn-light py-0 mt-1 dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
    Other Data
  </button>
  <ul class="dropdown-menu dropdown-menu-end">
    @for(ot of titleData; track ot; let n=$index;) {
      <li><button class="dropdown-item" type="button" (click)="optData[idx]=n;">{{ot}}</button></li>
    }
  </ul>
</div>

    <fieldset class="border p-2 rounded-2" style="height: 100%;">
      <legend class="w-auto px-2 ms-2 float-none fs-5">{{titleData[optData[idx]]}} {{idx+1}}:</legend>
      <div class="row mx-2 d-flex flex-wrap justify-content-between" 
        style="margin-top: -10px; max-height: 300px; overflow: auto;">

      @if(optData[idx]==0) {
        <table id="orgTable" class="table table-striped w-100">
          <thead>
            <tr>
              <th>#</th>
              <th>Person Name</th>
              <th>Username</th>
              <th>Reg. Date</th>
              <th>Active?</th>
              <!-- <th style="text-align: end;">Action</th> -->
            </tr>
          </thead>
          <tbody *ngIf="orgd.users && orgd.users.length">
            @for(data of orgd.users; track $index; let idx = $index;) {
            <tr>
              <td>{{idx+1}}.</td>
              <td>{{data.display_name}}
              <small class="text-primary" *ngIf="user.user_role[0].code=='spr' && data.inst_name"><br>({{data.inst_name}})</small></td>
              <td>{{data.user_name}}
                <small class="text-primary" *ngIf="user.user_role[0].code=='spr' && data.source_schema"><br>[{{data.source_schema}}]</small>
              </td>
              <td>{{data?.cur_date?.substr(0,10)}}</td>
              <td>{{data.is_active}}</td>
              <!-- <td>
                <div class="d-flex gap-2 justify-content-end" *ngIf="data.user_name">
                  <span style="cursor: pointer;" title="View KYC Details"
                    *ngIf="user.user_role[0].code=='spr' && (data.source_schema && data.source_schema.substr(0,2)!='x_') && 
                    data.institute" data-bs-toggle="modal" data-bs-target="#staticBackdrop2">
                    <i class="bi bi-window-stack"></i>
                  </span>

                  <span style="cursor: pointer;" data-bs-toggle="modal" data-bs-target="#frmBackdrop"
                    title="Modify">
                    <i class="bi bi-pencil-square text-success"></i>
                  </span>

                  <span style="cursor: pointer;" title="Delete">
                    <i class="bi bi-trash3 text-danger"></i>
                  </span>
                </div>
              </td> -->
            </tr>
            }
          </tbody>
        </table>

        <div class="text-danger" align="center" *ngIf="orgd.users && !orgd.users.length && !loading">
          <i class="bi bi-x-circle"></i> No data available.
        </div>
      }

      @if(optData[idx]==1) {
        @for(cn of orgd.contacts; track $index; let idx = $index;) {
        <div class="col-sm-6 mb-3">
          <div class="card">
            <div class="card-body">
              <h5 class="card-title" [class.text-success]="cn.is_primary">
                <i class="bi bi-person-check-fill me-2" *ngIf="cn.is_primary"></i>
                <i class="bi bi-person me-2" *ngIf="!cn.is_primary"></i>
                {{cn.person_name}} 
                <span class="fw-normal">({{dataService.getDesiName(cn.person_desi)}})</span>
              </h5>
              <p class="card-text my-0"><i class="bi bi-envelope me-3"></i> <a href="mailto:{{cn.email_id}}">{{cn.email_id}}</a></p>
              <p class="card-text my-0"><i class="bi bi-telephone me-3"></i> <a href="tele:{{cn.mobile_no1}}">{{cn.mobile_no1}}</a></p>
              <p class="card-text my-0"><i class="bi bi-telephone me-3"></i> <a href="tele:{{cn.mobile_no2}}">{{cn.mobile_no2}}</a></p>
            </div>
          </div>
        </div>
        }

        <div class="text-danger" align="center" *ngIf="orgd.contacts && !orgd.contacts.length && !loading">
          <i class="bi bi-x-circle"></i> No data available.
        </div>
      }

      @if(optData[idx]==2) {
        <div class="col-sm-4 mb-3">
          <div class="card">
            <div class="card-body py-1 text-center">
              <p class="card-text my-0">Package</p>
              <h5 class="card-title">{{dataService.getPackageName(orgd.package.pkg_code)}}</h5>
            </div>
          </div>
        </div>
        <div class="col-sm-4 mb-3">
          <div class="card">
            <div class="card-body py-1 text-center">
              <p class="card-text my-0">Bill Cycle</p>
              <h5 class="card-title">{{orgd.package.bill_cycle}}</h5>
            </div>
          </div>
        </div>
        <div class="col-sm-4 mb-3">
          <div class="card">
            <div class="card-body py-1 text-center">
              <p class="card-text my-0">Students</p>
              <h5 class="card-title">{{orgd.package.std_counts}}</h5>
            </div>
          </div>
        </div>

        <div class="col-sm-4 mb-3">
          <div class="card">
            <div class="card-body py-1 text-center">
              <p class="card-text my-0">Bill Amount</p>
              <h5 class="card-title">{{orgd.package.total_amount}}/-</h5>
            </div>
          </div>
        </div>
        <div class="col-sm-4 mb-3">
          <div class="card">
            <div class="card-body py-1 text-center">
              <p class="card-text my-0">Paid Amount</p>
              <h5 class="card-title">{{orgd.package.paid_amount}}/-</h5>
            </div>
          </div>
        </div>
        <div class="col-sm-4 mb-3">
          <div class="card">
            <div class="card-body py-1 text-center">
              <p class="card-text my-0">Balance Amount</p>
              <h5 class="card-title">{{orgd.package.total_amount - orgd.package.paid_amount}}/-</h5>
            </div>
          </div>
        </div>

        <div class="col-sm-4 mb-3">
          <div class="card">
            <div class="card-body py-1 text-center">
              <p class="card-text my-0">Pay Type</p>
              <h5 class="card-title">{{orgd.package.paid_offline ? 'Offline' : 'Online'}}</h5>
            </div>
          </div>
        </div>
        <div class="col-sm-4 mb-3">
          <div class="card">
            <div class="card-body py-1 text-center">
              <p class="card-text my-0">Start Date</p>
              <h5 class="card-title">{{dataService.ymd2dmy(orgd.package.start_date)}}</h5>
            </div>
          </div>
        </div>
        <div class="col-sm-4 mb-3">
          <div class="card">
            <div class="card-body py-1 text-center">
              <p class="card-text my-0">End Date</p>
              <h5 class="card-title">{{dataService.ymd2dmy(orgd.package.exp_date)}}</h5>
            </div>
          </div>
        </div>


        <div class="text-danger" align="center" *ngIf="!orgd.package && !loading">
          <i class="bi bi-x-circle"></i> No data available.
        </div>
      }

      @if(optData[idx]==3) {

        <div class="text-danger" align="center" *ngIf="!loading">
          <i class="bi bi-x-circle"></i> No data available.
        </div>
      }

      </div>
    </fieldset>
  </div>
</div>
}
</ng-container>
<div>&nbsp;</div>
